import { render, staticRenderFns } from "./MoveQuartersDialog.vue?vue&type=template&id=234c123d&scoped=true&"
import script from "./MoveQuartersDialog.vue?vue&type=script&lang=js&"
export * from "./MoveQuartersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c123d",
  null
  
)

export default component.exports